import { APP_CONFIG, MOBILE_VIEW_THRESHOLD_PX, ROUTE_HOMEPAGE } from '@1bill-app/constants';
import { CreditCheckResp, DoCreditCheck } from '@1bill-app/interfaces/one-bill-service-b';
import { ApiService } from '@1bill-app/services/api/api.service';
import { solveBrowserCompatibility } from '@1bill-app/services/custom-functions/custom-functions';
import {
  getAddressDetails,
  GoogleAddressService
} from '@1bill-app/services/google/google-address.service';
import { HomeService } from '@1bill-app/services/home/home.service';
import { SettingsService } from '@1bill-app/services/settings/settings.service';
import { Settings } from '@1bill-app/services/settings/settings.store';
import {
  CustomValidationService,
  DATE_MASK,
  MAX_DATE,
  MAX_DOB,
  MIN_DATE,
  MIN_DOB,
  safariDateToStandardDate,
  standardDateToSafariDate,
  validateDOB,
  validateExpiryDate
} from '@1bill-app/services/validation/custom-validation.service';
// import { catchError, map } from 'rxjs/operators';
// import { HttpErrorResponse } from '@angular/common/http';
import { PhoneValidator } from '@1bill-app/services/validation/phone.validator';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LoadingController, NavController, Platform, ToastController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';

export enum AddressTypes {
  CURRENT = 'CURRENT',
  PRIOR = 'PRIOR',
  MAILING = 'MAILING',
}
/**
 * Page for showing credit score form.
 */
@Component({
  selector: 'app-credit-score',
  templateUrl: './credit-score.page.html',
  styleUrls: ['./credit-score.page.scss'],
})
export class CreditScorePage implements OnInit {
  creditScoreForm: FormGroup;
  agreeTOS = false;
  public _prev: string;
  checkError: any;
  creditScoreLastChecked: string;
  checkWarning: any;
  saving: boolean;
  isSafariDesktop: boolean;
  addressPlaceId: string;
  addressPriorPlaceId: string;

  // @ViewChild('searchInput', {static: false}) searchInput: IonSearchbar;
  pageTitle = 'Credit Score';
  errorMessage: any;
  isAgreeTOS: boolean;
  loading: any;
  // TODO: put mask in validation service
  phoneMask = [/[0]/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/];
  searchingAddressPlace = false;
  searchingAddressPlacePrior = false;
  showHasPriorAddress = false;
  creditScore: any;

  minDate = MIN_DATE;
  maxDate = MAX_DATE;
  minDob = MIN_DOB;
  maxDob = MAX_DOB;

  safariDateMask = DATE_MASK;

  datePlaceholder = 'dd/mm/yyyy';
  addressTypes = AddressTypes;
  constructor(
    public platform: Platform,
    private route: ActivatedRoute,
    private logger: NGXLogger,
    private _cusValidation: CustomValidationService,
    private toastCtrl: ToastController,
    private _api: ApiService,
    private _gAddSrv: GoogleAddressService,
    private homeService: HomeService,
    private loadingController: LoadingController,
    private navCtrl: NavController,
    private settingsService: SettingsService,
  ) {
    this.isSafariDesktop = this._cusValidation.isSafariDesktop();
    this.logger.log('this.isSafariDesktop',this.isSafariDesktop);
    
    this.initForm();
  }

  ngOnInit() {
    this._prev = decodeURIComponent(this.route.snapshot.queryParamMap.get('prev') || '/');

    this.logger.debug('prev route: ', this._prev);
    // TODO: get credit score last checked date
    // this._api.creditHistory().subscribe(res=>{
    //   if(res.success){
    //     this.creditScoreLastChecked = res.data[0].date;
    //   }
    // });
  }
  ionViewWillEnter() {
    this.fetchData();
  }
  /**
   * Fetch data to prefill form.
   */
  async fetchData() {
    //TODO: use caching
    const loadingSpinner = await this.loadingController.create({
      message: 'Loading user data...',
    });
    loadingSpinner.present();
    this.settingsService.fetch().subscribe(
      (res) => {
        this.logger.debug('set res', res);
        this.updateFormWithState(res);
      },
      (err) => {
        this.logger.error('settingsService.fetch', err);
      }, () => {
        loadingSpinner.dismiss();
      }
    );
  }
  /**
   * Initiates credit score form and sets validation rules.
   */
  initForm() {
    // FIXME: Check if unfilled data (date) has issue.
    // FIXME: google address search if did not select value
    const expiryDateValidators =[Validators.required, validateExpiryDate(this.platform)];
    this.creditScoreForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      otherName: new FormControl('', []),
      surName: new FormControl('', [Validators.required]),
      mobileNumber: new FormControl('', [PhoneValidator.validCountryPhone('AU')]),
      email: new FormControl('', [
        Validators.email,
        Validators.required,
        // Validators.pattern('[a-zA-Z0-9._-]{2,}@[a-zA-Z]{2,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})'),
      ]),
      dateOfBirth: new FormControl('', [
        Validators.required,
        validateDOB(this.platform),
      ]),
      addressFull: new FormControl('', [Validators.required]),
      hasPriorAddress: new FormControl(false, [Validators.required]),
      addressFullPrior: new FormControl('', [
        // Validators.required
      ]),
      // agreeTOS: new FormControl(false, [Validators.requiredTrue]),
      identificationSelected: new FormControl({
        value:"driver_licence", disabled:false 
    }, [Validators.required]),
      idPassport: new FormGroup({
        id: new FormControl(''),
        expiry: new FormControl(
          '',
          validateExpiryDate(this.platform)
        ),
      }),
      idDriverLicence: new FormGroup({
        id: new FormControl('', Validators.required),
        expiry: new FormControl(
          '',
          expiryDateValidators
        ),
      }),
      idMedicare: new FormGroup({
        id: new FormControl(''),
        expiry: new FormControl(
          '',
          validateExpiryDate(this.platform)
        ),
      }),
    });

    const crForm = this.creditScoreForm;

    crForm.get('hasPriorAddress').valueChanges.subscribe((value) => {
      if (value) {
        crForm.get('addressFullPrior').setValidators(Validators.required);
      } else {
        crForm.get('addressFullPrior').clearValidators();
      }
      crForm.get('addressFullPrior').updateValueAndValidity();
    });
    const formId = crForm.get('identificationSelected');
    formId.valueChanges.subscribe((value) => {
      crForm.get('idDriverLicence.id').clearValidators();
      crForm.get('idDriverLicence.expiry').clearValidators();
      
      crForm.get('idPassport.id').clearValidators();
      crForm.get('idPassport.expiry').clearValidators();

      crForm.get('idMedicare.id').clearValidators();
      crForm.get('idMedicare.expiry').clearValidators();

      if (value=="driver_licence") {
        crForm.get('idDriverLicence.id').setValidators(Validators.required);
        crForm.get('idDriverLicence.expiry').setValidators(expiryDateValidators);
      } else if(value =="passport") {
        crForm.get('idPassport.id').setValidators(Validators.required);
        crForm.get('idPassport.expiry').setValidators(expiryDateValidators);
      }else if(value =="medicare") {
        crForm.get('idMedicare.id').setValidators(Validators.required);
        crForm.get('idMedicare.expiry').setValidators(expiryDateValidators);
      }
      crForm.get('idDriverLicence.id').updateValueAndValidity();
      crForm.get('idDriverLicence.expiry').updateValueAndValidity();
      
      crForm.get('idPassport.id').updateValueAndValidity();
      crForm.get('idPassport.expiry').updateValueAndValidity();

      crForm.get('idMedicare.id').updateValueAndValidity();
      crForm.get('idMedicare.expiry').updateValueAndValidity();
    });
  }
  /**
   * Updates form based upon previously provided values.
   * @param settings
   */
  updateFormWithState(settings: Settings) {
    let prefillValues = {
      firstName: settings.firstName,
      surName: settings.lastName,
      email: settings.email,
      mobileNumber: settings.mobileNumber,
      addressFull: settings.address,
      dateOfBirth: this.isSafariDesktop
        ? standardDateToSafariDate(settings.dateOfBirth)
        : settings.dateOfBirth,
      // identificationSelected: settings.identificationSelected, // credit check only supports driver licence
      idPassport: settings.idPassport || {},
      idDriverLicence: settings.idDriverLicence || {},
      idMedicare: settings.idMedicare || {},
    };

    prefillValues = prefillValues = {
      ...prefillValues,
      ...{ ...solveBrowserCompatibility(settings, this.isSafariDesktop) },
    };

    this.creditScoreForm.patchValue(prefillValues);

    // if (settings.addressJson && settings.addressJson.placeId) {
    //   this.addressPlaceId = settings.addressJson.placeId;
    // } else 
    if (settings.address) {
      this.logger.log('Running automatic address check...');
      this._gAddSrv.getPlacePredictions(settings.address).then((res) => {
        if (res.length) {
          this.addressPlaceId = res[0].placeId; // TODO: check if address not found
        }
      });
    }
  }

  get hasPriorAddress() {
    return this.creditScoreForm.get('hasPriorAddress');
  }
  get addressFull() {
    return this.creditScoreForm.get('addressFull');
  }
  get addressFullPrior() {
    return this.creditScoreForm.get('addressFullPrior');
  }
  get dateOfBirth() {
    return this.creditScoreForm.get('dateOfBirth');
  }
  get idPassportExpiry() {
    return this.creditScoreForm.get('idPassport').get('expiry');
  }
  get idMedicareExpiry() {
    return this.creditScoreForm.get('idMedicare').get('expiry');
  }
  get idDriverLicenceExpiry() {
    return this.creditScoreForm.get('idDriverLicence').get('expiry');
  }
  /**
   * Sets address item into form.
   */
  setAddress(
    item: { success: boolean; data: { desc: string; placeId: string } },
    type: AddressTypes,
  ) {
    this.logger.debug(item, type);
    if (type === AddressTypes.CURRENT) {
      this.searchingAddressPlace = false;
      if (item.success) {
        this.creditScoreForm.patchValue({ addressFull: item.data.desc });
        this.addressPlaceId = item.data.placeId;
      }
    }
    if (type === AddressTypes.PRIOR) {
      this.searchingAddressPlacePrior = false;
      if (item.success) {
        this.creditScoreForm.patchValue({ addressFullPrior: item.data.desc });
        this.addressPriorPlaceId = item.data.placeId;
      }
    }
  }
  /**
   * Sets addressFullPrior field of form to null when prior address is toogled.
   */
  priorAddressToggle() {
    if (this.hasPriorAddress.value === false) {
      this.creditScoreForm.patchValue({ addressFullPrior: null });
    }
  }
  /**
   * Shows searchbar for address search based upon address type.
   * @param type
   */
  showAddressSearch(type: AddressTypes) {
    if (type === AddressTypes.CURRENT) {
      this.searchingAddressPlace = true;
    }

    if (type === AddressTypes.PRIOR) {
      this.searchingAddressPlacePrior = true;
    }
  }
  /**
   * Gets identification values based upon selected identificatio type
   * and sets
   */
  getSelectedIdentificationType() {
    let type: any;
    const selected = this.creditScoreForm.get('identificationSelected').value;

    switch (selected) {
      case 'driver_licence':
        type = {
          key: selected,
          value: 'Driver Licence',
        };

        this.creditScoreForm.get('idDriverLicence').enable();
        this.creditScoreForm.get('idPassport').disable();
        this.creditScoreForm.get('idMedicare').disable();
        break;
      case 'passport':
        type = {
          key: selected,
          value: 'Passport',
        };
        this.creditScoreForm.get('idPassport').enable();
        this.creditScoreForm.get('idDriverLicence').disable();
        this.creditScoreForm.get('idMedicare').disable();
        break;
      case 'medicare':
        type = {
          key: selected,
          value: 'Medicare',
        };
        this.creditScoreForm.get('idMedicare').enable();
        this.creditScoreForm.get('idDriverLicence').disable();
        this.creditScoreForm.get('idPassport').disable();
        break;
      default:
        type = {
          key: null,
          value: null,
        };
        break;
    }

    this.creditScoreForm.get('idDriverLicence').updateValueAndValidity();
    this.creditScoreForm.get('idPassport').updateValueAndValidity();
    this.creditScoreForm.get('idMedicare').updateValueAndValidity();

    return type;
  }
  /**
   * Submits the form to get credit score.
   */
  async onSubmit() {
    const submitted = this.creditScoreForm.value;
    this.logger.debug('Credit score submitted data:',submitted);
    this.checkError = null;
    this.checkWarning = null;

    this.logger.debug(this.addressPlaceId);

    if (!this.addressPlaceId) {
      this.showError('Please select address.');
      return;
    }

    if(this.creditScoreForm.invalid){
      this.showError('Please enter all the required fields.');
      return;
    }

    if (!this.agreeTOS) {
      this.showError('Please agree Terms.');
      return;
    }
    this.saving = true;
    const add = await getAddressDetails(this.addressPlaceId);
    this.logger.debug('add', add);

    const formData = {
      ...submitted,
      ...{
        address: add.result,
      },
    };

    if (this.hasPriorAddress.value) {
      const addPrior = await getAddressDetails(this.addressPriorPlaceId);
      Object.assign(formData, {
        addressPrior: addPrior.result,
      });
    }

    if (this.isSafariDesktop) {
      formData.dateOfBirth = safariDateToStandardDate(formData.dateOfBirth);

      if (formData.idDriverLicence && formData.idDriverLicence.expiry) {
        formData.idDriverLicence.expiry = safariDateToStandardDate(
          formData.idDriverLicence.expiry,
        );
      }

      if (formData.idMedicare && formData.idMedicare.expiry) {
        formData.idMedicare.expiry = safariDateToStandardDate(formData.idMedicare.expiry);
      }

      if (formData.idPassport && formData.idPassport.expiry) {
        formData.idPassport.expiry = safariDateToStandardDate(formData.idPassport.expiry);
      }
    }

    // this.logger.debug(formData);

    const data: DoCreditCheck = formData;

    this._api
      .creditCheck(data)
      .toPromise()
      .then((res) => {
        // this.logger.log(res);
        this.analyzeCreditScore(res);
      })
      .catch((err) => {
        this.logger.error('creditCheck api err: ', err);

        this.showError('Credit API error!', true);
      })
      .finally(() => (this.saving = false));
  }
  /**
   * Analyzes the success of credit check and
   * displays success or error accordingly.
   * @param data
   */
  async analyzeCreditScore(data: CreditCheckResp) {
    if (data.response.hasBestMatch) {
      this.showSuccess('Credit Score submitted.');
      this.creditScore = data.response.score;
      // TODO: save credit score to storage here
      // await this._storage.setItem({key: StorageItemKeys.CREDIT_SCORE, value: this.creditScore}); todo v2
      this.homeService.triggerFetchHomeData('CreditScorePage::analyzeCreditScore()', true);
      await this.navCtrl.navigateRoot([ROUTE_HOMEPAGE]);
    } else if (data.response.hasError) {
      // this.checkError = 'Please verify your details are correct.';
      this.checkError = data.response.error[data.response.error.length - 1];
      this.showError(`Error: ${this.checkError}`, true);
    } else if (data.response.hasWarning) {
      // this.checkWarning = 'Please verify your details are correct.';
      this.checkWarning = data.response.warning[data.response.warning.length - 1];
      this.showError(`Warning: ${this.checkWarning}`, false);
    }
  }
  /**
   * Shows success after credit score submitted successfully.
   * @param message
   */
  async showSuccess(message: string) {
    const toast = await this.toastCtrl.create({
      message,
      duration: APP_CONFIG.TOAST_SUCCESS_DURATION,
      // showCloseButton: true,
      // closeButtonText: APP_CONFIG.TOAST_SUCCESS_CLOSE_TEXT,
      color: 'success',
    });
    await toast.present();
  }
  /**
   * Shows error if there is failure.
   * @param message
   */
  async showError(err: any, danger = false) {
    if (!err) {
      return;
    }
    const message = err.statusText || err.message || err;
    const toast = await this.toastCtrl.create({
      message,
      duration: APP_CONFIG.TOAST_ERROR_DURATION,
      // showCloseButton: true,
      // closeButtonText: APP_CONFIG.TOAST_ERROR_CLOSE_TEXT,
      color: danger ? 'danger' : 'warning',
      // cssClass: ['toast-error']
    });
    await toast.present();
  }

  get isDesktopView() {
    return this.platform.width() >= MOBILE_VIEW_THRESHOLD_PX;
  }
}
